// -----------------------------------------------------------------------------
// Scripts for slider
// -----------------------------------------------------------------------------

$(function () {
	const sliders = $('.slider');

	$.each(sliders, function (index, value) {
		const singleSlider = $(this).find('.slider__content').attr('id');

		$(`#${singleSlider}`).slick({
			autoplay: false, //true,
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			fade: true,
			arrows: false,
			dots: true,
			adaptiveHeight: false,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						adaptiveHeight: true,
					}
				}
			],
			customPaging: function (slider, i) {
				return '<span class="dot"></span>';
			},
		});
	});
});